export default {
      id: "sli-pie-chart-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b3fb107f.svg#sli-pie-chart",
      toString: function () {
        return this.url;
      }
    }